import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faShieldAlt,
  faChartLine,
  faCertificate,
  faHeadset,
  faUserShield,
  faMapMarkedAlt,
  faChalkboardTeacher,
  faLaptopMedical,
} from '@fortawesome/free-solid-svg-icons';
import drFabioImage from '../assets/pictures/foto-fabio.png';
import drRubensImage from '../assets/pictures/foto-rubens.png';
import folder from '../assets/pictures/folder.png';
import hospitalPhoto1 from '../assets/pictures/hospital1.jpg';
import hospitalPhoto2 from '../assets/pictures/hospital2.jpg';
import hospitalPhoto3 from '../assets/pictures/hospital3.jpg';
import '../styles/Home.css';

function Home() {
  return (
    <div className="home">
      <section className="hero">
        <div className="hero-content">
          <h1>
            Soluções Profissionais para{' '}
            <span className="text-highlight">Radiodiagnóstico</span>
          </h1>
          <p>
            Segurança e Confiabilidade - Sua clínica mais segura, seus exames
            mais confiáveis.
          </p>
          <div className="hero-buttons">
            <a href="/contact" className="btn btn-primary">
              Contato
            </a>
            <a href="/services" className="btn btn-secondary">
              Nossos Serviços
            </a>
          </div>
        </div>
      </section>

      <section className="services-highlight">
        <div className="container">
          <h2 className="section-title">Nossos Serviços</h2>
          <p className="section-subtitle">
            Conheça nossas soluções completas para o seu serviço.
          </p>

          <div className="services-cards">
            <div className="service-card">
              <div className="service-icon">
                <FontAwesomeIcon icon={faUserShield} />
              </div>
              <h3>Controle de Qualidade</h3>
              <p>
                Esteja com seus equipamentos em conformidade com as exigências
                da RDC 611/ANVISA e CNEN.
              </p>
              <a href="/services#personal" className="service-link">
                Saiba mais
              </a>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <FontAwesomeIcon icon={faMapMarkedAlt} />
              </div>
              <h3>Licenciamento ANVISA/CNEN</h3>
              <p>
                Nós assessoramos seu serviço junto a ANVISA e CNEN para obtenção
                de autorização de operação bem como renovação.
              </p>
              <a href="/services#licensing" className="service-link">
                Saiba mais
              </a>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <FontAwesomeIcon icon={faChalkboardTeacher} />
              </div>
              <h3>Testes de Aceitação</h3>
              <p>
                Executamos todos os testes de aceitação exigidos pela ANVISA e
                CNEN.
              </p>
              <a href="/services#tests" className="service-link">
                Saiba mais
              </a>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <FontAwesomeIcon icon={faLaptopMedical} />
              </div>
              <h3>Garantia da Qualidade</h3>
              <p>
                Elaboramos toda a documentação de planos e assessorias
                necessárias para o seu serviço.
              </p>
              <a href="/services#qa" className="service-link">
                Saiba mais
              </a>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <FontAwesomeIcon icon={faLaptopMedical} />
              </div>
              <h3>Supervisão em Proteção Radiológica</h3>
              <p>
                Temos profissionais especialistas para acompanhamento e
                supervisão contínua da proteção radiológica em seu serviço.
              </p>
              <a href="/services#supervision" className="service-link">
                Saiba mais
              </a>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <FontAwesomeIcon icon={faLaptopMedical} />
              </div>
              <h3>Treinamento em Radioproteção</h3>
              <p>
                Ofertamos todos os treinamentos de radioproteção necessários
                para sua equipe.
              </p>
              <a href="/services#training" className="service-link">
                Saiba mais
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="benefits-section">
        <div className="container">
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-icon">
                <FontAwesomeIcon icon={faShieldAlt} />
              </div>
              <h3>Controle de Qualidade</h3>
              <li>Radio X fixo e móvel</li>
              <li>Radio X Odontológico</li>
              <li>Arco cirúrgico</li>
              <li>Ultrassom</li>
              <li>Mamografia</li>
              <li>Tomografia Computadorizada</li>
              <li>Ressonância Magnética</li>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">
                <FontAwesomeIcon icon={faChartLine} />
              </div>
              <h3>Licenciamento ANVISA/CNEN</h3>
              <p>
                Atuação em todos os níveis, desde o projeto de blindagem até a supervisão de radioproteção.
              </p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">
                <FontAwesomeIcon icon={faCertificate} />
              </div>
              <h3>Testes de Aceitação</h3>
              <p>
                Executamos todos os testes de aceitação exigidos pela ANVISA e
                CNEN para todos os equipamentos médicos e odontológicos
                emissores de radiação, de acordo com suas portarias e norma
                CNEN-NN-3.05.
              </p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">
                <FontAwesomeIcon icon={faHeadset} />
              </div>
              <h3>Programa de Garantia da Qualidade</h3>
              <li>
                Controle da qualidade de monitores de laudo e negatoscópios;
              </li>
              <li>Controle da qualidade de detectores (DR, CR e filmes)</li>
              <li>Controle da qualidade de EPIs</li>
              <li>Controle da dosimetria pessoal mensal e anual;</li>
              <li>Projetos de blindagens;</li>
              <li>Assessoria em radioproteção.</li>
            </div>
          </div>
        </div>
      </section> */}

      <section className="company-core">
        <div className="container">
          <h2 className="section-title">Sobre a Safe Dose</h2>
          <p className="section-subtitle">
            A Safe Dose é uma empresa especializada em proteção radiológica e
            segurança em ambientes de diagnóstico por imagem. Nosso propósito é
            garantir que sua estrutura esteja segura, legalizada e preparada
            para qualquer fiscalização, promovendo ambientes confiáveis tanto
            para profissionais quanto para pacientes.
          </p>
          <div className="about-grid">
            <div className="about-image">
              <img src={folder} alt="Profissionais de dosimetria" />
            </div>
            <div className="about-content">
              <h3>Nossa Missão</h3>
              <p>
                Garantir a segurança radiológica através de monitoramento
                preciso e confiável, protegendo profissionais e pacientes de
                todo o país.
              </p>

              <h3>Experiência</h3>
              <p>
                Fundada em 2024, a Safe Dose se destaca no mercado por sua
                expertise em física médica
              </p>

              <h3>Nossos Valores</h3>
              <ul className="values-list">
                <li>
                  <span className="list-icon">✓</span> Confiança
                </li>
                <li>
                  <span className="list-icon">✓</span> Excelência
                </li>
                <li>
                  <span className="list-icon">✓</span> Inovação constante
                </li>
                <li>
                  <span className="list-icon">✓</span> Ética e responsabilidade
                </li>
              </ul>

              <a href="/services" className="btn btn-primary">
                Conheça Nossos Serviços
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="clients-section">
        <div className="container">
          <h2 className="section-title">Quem Confia em Nosso Trabalho</h2>
          <div className="clients-logos">
            <div className="client-logo">
              <img src={hospitalPhoto1} alt="Hospital A" />
            </div>
            <div className="client-logo">
              <img src={hospitalPhoto2} alt="Clínica B" />
            </div>
            <div className="client-logo">
              <img src={hospitalPhoto3} alt="Laboratório C" />
            </div>
            <div className="client-logo">
              <img src={hospitalPhoto1} alt="Centro Médico D" />
            </div>
            <div className="client-logo">
              <img src={hospitalPhoto2} alt="Hospital E" />
            </div>
          </div>
        </div>
      </section> */}

      <section className="testimonials">
        <div className="container">
          <h2 className="section-title">Quem Somos?</h2>
          <div className="testimonial-container">
            <div className="testimonial">
              <div className="testimonial-content">
                <p>Bacharel em Física pela UFSCar;</p>
                <p>
                  Residência em Física Médica da Radioterapia no A.C. Camargo
                  Cancer Center;
                </p>
                <p>Especialista em Radioterapia pela CNEN e ABFM;</p>
                <p>Supervisor em Radioproteção pela CNEN;</p>
                <p>Físico Médico na Clínica Irradiar;</p>
                <p>Presidente da Associação CuidaDores.</p>
              </div>
              <div className="testimonial-author">
                <img
                  src={drFabioImage}
                  alt="Dr. Fabio Alves"
                  className="author-image"
                />
                <div className="author-info">
                  <h4>Dr. Fabio Alves</h4>
                  <p>Supervisor em Radioproteção da SafeDose</p>
                </div>
              </div>
            </div>

            <div className="testimonial">
              <div className="testimonial-content">
                <p>Bacharel em Física Médica pela UFG;</p>
                <p>
                  Residência em Física Médica da Radioterapia pelo A.C. Camargo
                  Cancer Center;
                </p>
                <p>Especialista em Radioterapia pela CNEN;</p>
                <p>Supervisor de Proteção Radiológica pela CNEN;</p>
                <p>Físico Médico na Clínica Irradiar;</p>
                <p>MBA em Engenharia de Software pela USP;</p>
                {/* <p>Técnico em Eletromecânica pelo SENAI;</p> */}
              </div>
              <div className="testimonial-author">
                <img
                  src={drRubensImage}
                  alt="Dr. Carlos Silva"
                  className="author-image"
                />
                <div className="author-info">
                  <h4>Dr. Rubens Vieira</h4>
                  <p>Supervisor em Radioproteção da SafeDose</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>
              Pronto para garantir a proteção radiológica dos seus clientes e da
              sua equipe?
            </h2>
            <p>
              Entre em contato conosco hoje e descubra como podemos ajudar a sua
              instituição.
            </p>
            <a href="/contact" className="btn btn-primary">
              Solicite uma Proposta
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
